import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import {
  BetRank2Pipe,
  BetRankPipe,
} from '../modules/account/shared/bet-rank.pipe';
import { BetPrintComponent } from './components/bet-print/bet-print.component';
import { BettingSlipModalComponent } from './components/betting-slip-popup/betting-slip-modal.component';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';
import { MessageModalComponent } from './components/message-modal/message-modal.component';
import { AlphabetOnlyDirective } from './directives/alphabet-only.directive';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { NumericDirective } from './directives/numeric.directive';
import { TwoDigitDecimaNumberDirective } from './directives/two-digit-decimal-number.directive';
import { BetTypePipe } from './pipes/bet-type.pipe';
import { RaceResultBettingTypePipe } from './pipes/race-result-betting-type.pipe';
import { BettingTypePipe } from './pipes/betting-type.pipe';
import { CapitalizeFirstPipe } from './pipes/capitalize-first.pipe';
import { JoinCommaRunnersPipe } from './pipes/join-comma.pipe';
import { RaceAnnexPipe } from './pipes/race-annex.pipe';
import { TenderingTextYearPipe } from './pipes/tendering-text-year.pipe';
import { TenderingTextPipe } from './pipes/tendering-text.pipe';
import { OpportunityComponent } from './components/opportunity/opportunity.component';
import { TooltipModule } from 'primeng/tooltip';
import { RaceCoursePipe } from './pipes/race-course.pipe';
import { RaceNoPipe } from './pipes/race-no.pipe';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { LoginPopupComponent } from './components/login-popup/login-popup.component';
import { PasswordModule } from 'primeng/password';
import { DropdownModule } from 'primeng/dropdown';
import { LegSelectionPipe } from '../modules/race/pipes/leg-selection.pipe';
import { NgxBarcodeModule } from 'ngx-barcode';
import { TopWiningComponent } from './components/top-wining/top-wining.component';
import { RaceFooterComponent } from '../modules/race/components/race-footer/race-footer.component';
import { YourBettingInfoComponent } from './components/your-betting-info/your-betting-info.component';
import { GetFlagPipe } from './pipes/get-flag.pipe';
import { SortablejsModule } from 'ngx-sortablejs';
import { TranslateDataByLanguagePipe } from './pipes/translate-data-by-language.pipe';
import { StatusBadgeClassPipe } from './pipes/status-badge-class.pipe';
import { StatusBtnClassPipe } from './pipes/status-btn-class.pipe';
import { CryptoPrecisionPipe } from './pipes/crypto-precision.pipe';
import { CryptoDepositComponent } from './components/crypto-deposit/crypto-deposit.component';
import { CryptoWithdrawalComponent } from './components/crypto-withdrawal/crypto-withdrawal.component';
import { CryptoTransactionModalComponent } from './components/crypto-transaction-modal/crypto-transaction-modal.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { RecaptchaModule } from "ng-recaptcha";
import { RegisterPopupComponent } from './components/register-popup/register-popup.component';
import { WelcomePopupComponent } from './components/welcome-popup/welcome-popup.component';
import { HomeAnnouncementComponent } from './components/home-announcement/home-announcement.component';

@NgModule({
  declarations: [
    HomeAnnouncementComponent,
    MessageModalComponent,
    LoadingScreenComponent,
    NumbersOnlyDirective,
    AlphabetOnlyDirective,
    NumericDirective,
    TwoDigitDecimaNumberDirective,
    BetRankPipe,
    BetRank2Pipe,
    JoinCommaRunnersPipe,
    RaceAnnexPipe,
    TenderingTextPipe,
    TenderingTextYearPipe,
    CapitalizeFirstPipe,
    BetTypePipe,
    BettingTypePipe,
    RaceResultBettingTypePipe,
    MessageDialogComponent,
    BetPrintComponent,
    BettingTypePipe,
    RaceCoursePipe,
    RaceNoPipe,
    OpportunityComponent,
    RaceFooterComponent,
    YourBettingInfoComponent,
    BettingSlipModalComponent,
    LoginPopupComponent,
    RegisterPopupComponent,
    WelcomePopupComponent,
    LegSelectionPipe,
    TopWiningComponent,
    GetFlagPipe,
    TranslateDataByLanguagePipe,
    StatusBadgeClassPipe,
    StatusBtnClassPipe,
    CryptoPrecisionPipe,
    CryptoDepositComponent,
    CryptoWithdrawalComponent,
    CryptoTransactionModalComponent,
    ConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    QRCodeModule,
    ReactiveFormsModule,
    // PasswordModule,
    // InputTextModule,
    TranslateModule,
    DynamicDialogModule,
    TooltipModule,
    AccordionModule,
    ToastModule,
    PasswordModule,
    DropdownModule,
    NgxBarcodeModule,
    ClipboardModule,
    SortablejsModule.forRoot({ animation: 150 }),
    RecaptchaModule
  ],
  exports: [
    HomeAnnouncementComponent,
    TranslateModule,
    LoadingScreenComponent,
    BetPrintComponent,
    NumbersOnlyDirective,
    AlphabetOnlyDirective,
    NumericDirective,
    TwoDigitDecimaNumberDirective,
    BetRankPipe,
    BetRank2Pipe,
    JoinCommaRunnersPipe,
    RaceAnnexPipe,
    TenderingTextPipe,
    TenderingTextYearPipe,
    CapitalizeFirstPipe,
    BetTypePipe,
    BettingTypePipe,
    RaceResultBettingTypePipe,
    OpportunityComponent,
    RaceFooterComponent,
    YourBettingInfoComponent,
    BettingSlipModalComponent,
    LoginPopupComponent,
    LegSelectionPipe,
    NgxBarcodeModule,
    TopWiningComponent,
    GetFlagPipe,
    RaceCoursePipe,
    RaceNoPipe,
    TranslateDataByLanguagePipe,
    StatusBadgeClassPipe,
    StatusBtnClassPipe,
    CryptoPrecisionPipe,
    CryptoTransactionModalComponent,
  ],
  entryComponents: [
    MessageModalComponent,
    MessageDialogComponent,
    BettingSlipModalComponent,
    LoginPopupComponent,
    RegisterPopupComponent,
    WelcomePopupComponent,
    CryptoTransactionModalComponent,
    ConfirmDialogComponent,
  ],
})
export class SharedModule { }
